export const BUILDER_LANGUAGE_KEY = 'userLanguage'

export type BuilderLanguage = 'en' | 'uk'

const normalizeLanguage = (value?: string | null): BuilderLanguage | null => {
    if (!value) {
        return null
    }

    const code = value.toLowerCase()

    if (code === 'en') {
        return 'en'
    }

    if (code === 'uk' || code === 'ua') {
        return 'uk'
    }

    return null
}

export const resolveBuilderLanguage = (
    search?: string,
    storedLanguage?: string | null,
): BuilderLanguage => {
    const query =
        search ?? (typeof window === 'undefined' ? '' : window.location.search)
    const fromQuery = normalizeLanguage(
        new URLSearchParams(query).get('language'),
    )

    if (fromQuery) {
        return fromQuery
    }

    let stored = storedLanguage

    if (stored === undefined) {
        stored =
            typeof window === 'undefined'
                ? null
                : window.localStorage.getItem(BUILDER_LANGUAGE_KEY)
    }

    return normalizeLanguage(stored) ?? 'en'
}
